export const isLanguageTtsEngineConfigured = (tts) => tts === true || (typeof tts === 'string' && tts.length > 0);
export const isLanguageTtsAvailable = (setup, langIso) => {
    if (!(setup.ttsEnabled ?? false)) {
        return false;
    }
    const language = setup.languages.find((lang) => lang.iso === langIso);
    return language !== undefined && isLanguageTtsEngineConfigured(language.tts);
};
